import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61e1ad9e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list" }
const _hoisted_2 = { class: "list-title" }
const _hoisted_3 = { class: "info" }
const _hoisted_4 = { class: "num" }

import { ref, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getBlocks } from "@/api/_common";
import Title from "@/components/SecondaryTitle.vue";
import List from "@/components/List.vue";
import HelperTools from "@/utils/helper";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const pageSize = 10;

const route = useRoute();
const router = useRouter();
const currentPage = computed(() => Number(route.query.page));

const blocks = ref([]);
const rowData = ref([
  {
    prop: "Number",
    label: "blocklist.height",
    method: (row) => row.Number,
  },
  {
    prop: "TxNumber",
    label: "blocklist.txns",
    method: (row) => row.TxNumber,
  },
  {
    prop: "Validators",
    label: "blocklist.Validators",
    method: (row) => row.Validators,
  },
  {
    prop: "Time",
    label: "blocklist.time",
    method: (row) => HelperTools.getTransDate(row.Time),
  },
]);

const getBlockList = async () => {
  const res = await getBlocks({
    PageNo: currentPage.value - 1,
    PageSize: pageSize,
  });
  blocks.value = res;
};

const handlePageChange = async (newPage) => {
  await router.replace({
    query: {
      page: newPage,
    },
  });
  await getBlockList();
};
const handleRowClick = (row) => {
  router.push({ name: "Block", params: { Number: row.Number } });
};

onMounted(async () => {
  if (!route.query.page) {
    await router.replace({
      query: {
        page: 1,
      },
    });
  }
  await getBlockList();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Title, {
        title: _ctx.$t('blocklist.name')
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("blocklist.totalof")), 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(HelperTools).toFinancialVal(blocks.value.TotalCount)), 1),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t("blocklist.block")), 1)
      ])
    ]),
    _createVNode(List, {
      data: blocks.value.Blocks,
      handle: handleRowClick,
      handleCurrentChange: handlePageChange,
      rowDatas: rowData.value,
      total: blocks.value.TotalCount,
      "current-page": _unref(currentPage)
    }, null, 8, ["data", "rowDatas", "total", "current-page"])
  ]))
}
}

})